import {
  createApiFactory,
  createApiRef,
  createPlugin,
  createRoutableExtension,
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import { AccessControlListClient } from '@agilelab/plugin-wb-access-control-common';
import {
  accessControlListApiRef,
  actionHandlerApiRef,
  ActionHandlerClient,
} from '@agilelab/plugin-wb-access-control';
import { dataProductRouteRef, rootRouteRef } from './routes';
import { metricsApiRef } from '@agilelab/plugin-wb-metrics';
import { DefaultMetricsClient } from '@agilelab/plugin-wb-metrics-common';
import { MarketplaceApi } from '@agilelab/plugin-wb-marketplace-common';

export const marketplaceApiRef = createApiRef<MarketplaceApi>({
  id: 'marketplace',
});

import {
  KnowledgeGraphManagerApi,
  KnowledgeGraphManagerClient,
} from './components/KnowledgeGraphManager/api';

/**
 * The API reference for the KnowledgeGraphManagerApi.
 * @public
 */
export const knowledgeGraphManagerApiRef =
  createApiRef<KnowledgeGraphManagerApi>({
    id: 'plugin.knowledge-graph-manager',
  });

export const marketplacePlugin = createPlugin({
  id: 'wb-marketplace',
  routes: {
    root: rootRouteRef,
    marketplaceProductRef: dataProductRouteRef,
  },
  apis: [
    createApiFactory({
      api: metricsApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new DefaultMetricsClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: actionHandlerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new ActionHandlerClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: accessControlListApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new AccessControlListClient({ discoveryApi, fetchApi }),
    }),
    createApiFactory({
      api: knowledgeGraphManagerApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new KnowledgeGraphManagerClient({ discoveryApi, fetchApi }),
    }),
  ],
});

export const MarketplacePage = marketplacePlugin.provide(
  createRoutableExtension({
    name: 'MarketplacePage',
    component: () => import('./components/Router').then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
